import { Flags } from '@common/constants/flags';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const useAppFlags = () => {
  const flags = useFlags();

  return {
    isDerivedRatesV2Enabled: flags[Flags.DerivedRatesV2],
    isAnalyticsCompareToEnabled: flags[Flags.AnalyticsCompareTo],
    is12MonthsBudgetBannerEnabled: flags[Flags.Show12MonthsBudgetBanner],
    isHideOverridePriceSubscriptionPage: flags[Flags.HideOverridePriceSubscription],
    isMinStayV3Enabled: flags[Flags.MinStayV3],
    isHomeScreenEnabled: flags[Flags.HomeScreen],
    isForeCastingV2Enabled: flags[Flags.ForeCastingV2],
    isGroupDisplacementRolloutEnabled: flags[Flags.GroupDisplacementRollout],
    isPricingCheeseLayersEnabled: flags[Flags.PricingCheeseLayers],
    isTenPercentFixedPricesThresholdEnabled: flags[Flags.TenPercentFixedPricesThreshold],
    isReportingDashboardV2Enabled: flags[Flags.ReportingDashboardV2],
    isAIChatBotEnabled: flags[Flags.AIChatBot],
    isPmsConfigFromBackendEnabled: flags[Flags.PmsConfigFromBackend],
    isMinStayV2Enabled: flags[Flags.MinStayV2],
    isMinStayMultipleRatePlansEnabled: flags[Flags.MinStayMultipleRatePlans],
    isShoulderNightDiscountEnabled: flags[Flags.IsShoulderNightDiscountEnabled],
    isReportingRateTypeAnalyticsEnabled: flags[Flags.ReportingRateTypeAnalytics],
    isSessionBasedAuthEnabled: flags[Flags.SessionBasedAuth]
  };
};
